import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import facebookFooter from "../images/facebook-footer.png";
import twitterFooter from "../images/twitter-footer.png";
import instagramFooter from "../images/instagram-footer.png";
import linkedinFooter from "../images/linkedin-footer.png";
import appStoreIcon from "../images/appStoreIcon.png";
import gplayIcon from "../images/GPlayStore.png";
import callIcon from "../images/fi-call-icon.svg";

import redcallIcon from "../images/redCall-icon.svg";
import orangecallIcon from "../images/orangeCall-icon.svg";



import { Link } from "react-router-dom";
import { sitePolicy } from "../asiosConfig";
import logo from "../images/ind-finallogo1.png";
import footerBG from "../images/footerBG.png";

import { FiYoutube } from "react-icons/fi";

function Footer() {
  const [footer, setFooter] = useState({});
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isSmallLaptop, setIsSmallLaptop] = useState(false);

  useEffect(() => {
    const fetchFooter = async () => {
      try {
        const response = await sitePolicy();
        if (response.status === 200 || response.status === 201) {
          setFooter(response.data.data);
        }
      } catch (error) {
        console.log("Something went wrong");
      }
    };
    fetchFooter();

    const handleResize = () => {
      const width = window.innerWidth;

      setIsMobile(window.innerWidth <= 576);
      setIsTablet(window.innerWidth > 576 && window.innerWidth <= 992);
      setIsSmallLaptop(width > 992 && width <= 1399); // Small Laptop: 993px – 1399px
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const linkStyle = {
    textDecoration: "none",
    color: "#4f4f4f",
    fontFamily: "Montserrat",
    transition: "all 0.3s ease",
    fontSize: "15px",
  };

  const handleHover = (e, isEnter) => {
    if (isEnter) {
      e.target.style.background = "linear-gradient(90deg, #F78C25, #FF3C3C)";
      e.target.style.webkitBackgroundClip = "text";
      e.target.style.webkitTextFillColor = "transparent";
    } else {
      e.target.style.background = "none";
      e.target.style.webkitBackgroundClip = "unset";
      e.target.style.webkitTextFillColor = "#4f4f4f";
    }
  };

  return (
    <div
     
      style={{
        backgroundImage: `url(${footerBG})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        fontFamily: "Montserrat",
        color: "#4f4f4f",
        borderTop: "0.8px solid linear-gradient(90deg, #f78c25, #ff3c3c)"
      }}
    >
      <div className="container" style={{

        padding: isMobile ? "30px 15px 0 15px" : "40px 0 0 0",

      }}>
        <div className="row align-items-start">
          {/* About Section */}
          <div
            className="col-lg-4 col-md-6 mb-4"
            style={{
              textAlign: "left",
              padding: isMobile ? "0 10px" : "0px 0px 0px 60px",
            }}
          >
            <img
              src={logo}
              alt="IND Matrimony logo"
              style={{
                marginBottom: "20px",
                maxWidth: isMobile ? "140px" : "180px",
                height: "auto",
              }}
            />
            {/* <h5 style={{ fontWeight: "600", marginBottom: "10px" }}>About us</h5> */}
            <p
              style={{
                fontSize: isMobile ? "15px" : "15px",
                lineHeight: "1.8",
                color: "#444",
              }}
            >
              India's most trusted matrimony platform. IND Matrimony provides
              verified profiles and personalized matches, ensuring a secure and
              simple path to finding your life partner.
            </p>

            {/* Phone Numbers */}

            {/* PHONE NUMBER BLOCKS */}
            <div
              style={{
                display: "flex",
                flexDirection: isMobile ? "column" : isSmallLaptop ? "column" : isTablet ? "column" : "row",
                gap: isMobile ? "12px" : isSmallLaptop ? "10px" : "16px",
                marginTop: "15px",
              }}
            >
              {/* ---- RED CALL BOX ---- */}
              <motion.div
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "10px 16px",
                  borderRadius: "7px",
                  background: "linear-gradient(360deg, #FFFFFF 0%, #FFE2E2 81%)",
                  width: "fit-content",
                  whiteSpace: "nowrap",
                  cursor: "pointer",
                }}
                whileHover={{ y: -3, boxShadow: "0px 4px 10px rgba(0,0,0,0.1)" }}
              >
                <img
                  src={redcallIcon}
                  alt="call"
                  style={{ width: "20px", marginRight: "8px" }}
                />
                <span
                  style={{
                    fontWeight: 600,
                    fontSize: "15px",
                    color: "#1A1A1A",
                    fontFamily: "Montserrat",
                  }}
                >
                  +91-8600555740
                </span>
              </motion.div>

              {/* ---- ORANGE CALL BOX ---- */}
              <motion.div
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "10px 16px",
                  borderRadius: "7px",
                  background: "linear-gradient(360deg, #FFFFFF 0%, #FFE8D4 88%)",
                  width: "fit-content",
                  whiteSpace: "nowrap",
                  cursor: "pointer",
                }}
                whileHover={{ y: -3, boxShadow: "0px 4px 10px rgba(0,0,0,0.1)" }}
              >
                <img
                  src={orangecallIcon}
                  alt="call"
                  style={{ width: "20px", marginRight: "8px" }}
                />
                <span
                  style={{
                    fontWeight: 600,
                    fontSize: "15px",
                    color: "#1A1A1A",
                    fontFamily: "Montserrat",
                  }}
                >
                  +91-9004191775
                </span>
              </motion.div>
            </div>



          </div>

          {/* Explore */}
          <div
            className="col-lg-2 col-md-6 mb-2"
            style={{
              textAlign: "left",
              padding: isMobile ? "0 10px" : "25px 25px 25px 22px",
              marginLeft: isMobile
                ? "0px"
                : isTablet
                  ? "0px"
                  : isSmallLaptop
                    ? "65px"
                    : "75px",
            }}
          >
            <h5 style={{ fontWeight: "600", marginBottom: "20px" }}>Explore</h5>
            {[
              { to: "/", text: "Home" },
              { to: "/about-us", text: "About Us" },
              { to: "/success-story", text: "Success Stories" },
              { to: "/center", text: "Ind Matrimony Centers" },
              { to: "/contact-us", text: "Contact Us" },
            ].map((item, i) => (
              <p key={i} style={{ marginBottom: "10px" }}>
                <Link
                  to={item.to}
                  style={linkStyle}
                  onClick={() => {
                    if (item.to === "/") {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }
                  }}
                >
                  <motion.span
                    initial={{ backgroundSize: "0% 2px", backgroundPosition: "0% 100%" }}
                    whileHover={{
                      backgroundSize: "100% 2px",
                      color: "#f78c25",
                      backgroundImage: "linear-gradient(90deg, #f78c25, #ff3c3c)"
                    }}
                    style={{
                      display: "inline-block",
                      backgroundImage: "linear-gradient(90deg, #f78c25, #ff3c3c)",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "0% 100%",
                      backgroundSize: "0% 2px",
                      transition: "background-size 0.3s ease",
                      paddingBottom: "2px"
                    }}
                  >
                    {item.text}
                  </motion.span>
                </Link>
              </p>
            ))}
          </div>

          {/* Legal */}
          <div
            className="col-lg-3 col-md-6 mb-4"
            style={{
              textAlign: "left",
              padding: isMobile
                ? "0 10px"
                  ? "20px 0px 0px 10px"
                  : isSmallLaptop
                : "25px 25px 25px 58px ",
              marginLeft: isMobile
                ? "0px"
                : isTablet
                  ? "0px"
                  : isSmallLaptop
                    ? "0px"
                    : "25px",
            }}
          >
            <h5 style={{ fontWeight: "600", marginBottom: "20px" }}>Legal</h5>
            {[
              { to: "/fraud-alert", text: "Fraud Alert" },
              { to: "/term-of-uses", text: "Terms of Use" },
              { to: "/cancellation-refund", text: "Cancellation and Refund" },
              { to: "/privacy-policy", text: "Privacy Policy" },
              { to: "/cookie-policy", text: "Cookie Policy" },
              { to: "/grievances", text: "Grievances" },
              { to: "/child-policy", text: "Child Safety Policy" },
            ].map((item, i) => (
              <p key={i} style={{ marginBottom: "10px" }}>
                <Link
                  to={item.to}
                  style={linkStyle}
                >
                  <motion.span
                    initial={{ backgroundSize: "0% 2px", backgroundPosition: "0% 100%" }}
                    whileHover={{
                      backgroundSize: "100% 2px",
                      color: "#f78c25",
                      backgroundImage: "linear-gradient(90deg, #f78c25, #ff3c3c)"
                    }}
                    style={{
                      display: "inline-block",
                      backgroundImage: "linear-gradient(90deg, #f78c25, #ff3c3c)",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "0% 100%",
                      backgroundSize: "0% 2px",
                      transition: "background-size 0.3s ease",
                      paddingBottom: "2px"
                    }}
                  >
                    {item.text}
                  </motion.span>
                </Link>
              </p>
            ))}
          </div>

          {/* App Section */}
          <div
            className="col-lg-2 col-md-6 mb-4"
            style={{
              textAlign: "left",
              padding: isMobile
                ? "0 10px"
                : isTablet
                  ? "20px 0px 0px 66px"
                  : isSmallLaptop
                    ? "20px 0px 0px 0px"
                    : "20px 0px 0px 40px",

              boxSizing: "border-box",
              overflow: "hidden",
            }}
          >
            <h5
              style={{
                fontWeight: "600",
                marginBottom: isMobile ? "0px" : "18px",
              }}
            >
              App Available On
            </h5>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                padding: "20px 20px 20px 0px ",
              }}
            >
              <motion.a
                href="https://apps.apple.com/in/app/ind-matrimony/id6741297825"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "inline-flex",
                  alignSelf: "flex-start", // <-- THIS FIXES IT
                  cursor: "pointer",
                }}
                whileHover={{ scale: 1.05, filter: "drop-shadow(0px 5px 15px rgba(0,0,0,0.2))" }}
                whileTap={{ scale: 0.95 }}
              >
                <img
                  src={appStoreIcon}
                  style={{ width: "140px", height: "auto", display: "block" }}
                  alt="App Store"
                />
              </motion.a>

              <motion.a
                href="https://play.google.com/store/apps/details?id=com.indmatrimony.ind_matrimony"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "inline-flex",
                  alignSelf: "flex-start", // <-- SAME FIX HERE
                  cursor: "pointer",
                }}
                whileHover={{ scale: 1.05, filter: "drop-shadow(0px 5px 15px rgba(0,0,0,0.2))" }}
                whileTap={{ scale: 0.95 }}
              >
                <img
                  src={gplayIcon}
                  style={{ width: "140px", height: "auto", display: "block" }}
                  alt="Google Play"
                />
              </motion.a>
            </div>
          </div>
        </div>
      </div>

      {/* FOOTER BOTTOM BAR */}
      <div
        style={{
          background:
            "linear-gradient(rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.3)), linear-gradient(90deg, #f78c25, #ff3c3c)",
          padding: "10px 0",
          color: "#fff",
          textAlign: "center",
          // marginBottom: "15px",
        }}
      >
        <div
          className="container d-flex flex-column flex-md-row justify-content-between align-items-center"
          style={{
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? "10px" : "0",
          }}
        >
          <p
            style={{
              fontSize: isMobile ? "12px" : "13px",
              fontWeight: "400",
              marginBottom: "0",
            }}
          >
            © Copyright 2025-2026 By IND Matrimony. All Rights Reserved.
          </p>

          <div
            className="socialIcons"
            style={{
              display: "flex",
              justifyContent: isMobile ? "center" : "flex-end",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <a
              href={
                footer?.fb_link ||
                "https://www.facebook.com/indmatrimonyofficial/"
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={facebookFooter}
                alt="Facebook"
                style={{ width: "20px", height: "auto" }}
              />
            </a>
            {/* <span
              style={{
                width: "2px",
                height: "16px",
                background: "#fff",
                opacity: 0.6,
              }}
            ></span> */}
            {/* <a
              href={footer?.twitter_link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={twitterFooter}
                alt="Twitter"
                style={{ width: "20px", height: "auto" }}
              />
            </a> */}
            <span
              style={{
                width: "2px",
                height: "16px",
                background: "#fff",
                opacity: 0.6,
              }}
            ></span>
            <a
              href={footer?.insta_link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={instagramFooter}
                alt="Instagram"
                style={{ width: "17px", height: "auto" }}
              />
            </a>
            <span
              style={{
                width: "2px",
                height: "16px",
                background: "#fff",
                opacity: 0.6,
              }}
            ></span>
            <a
              href={
                footer?.linkedin_link ||
                "https://www.linkedin.com/company/ind-matrimony/"
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={linkedinFooter}
                alt="LinkedIn"
                style={{ width: "20px", height: "auto" }}
              />
            </a>

            {/* Separator before YouTube */}
            <span
              style={{
                width: "2px",
                height: "16px",
                background: "#fff",
                opacity: 0.6,
              }}
            ></span>

            {/* YouTube Icon */}
            <a
              href={
                footer?.youtube_link || "https://www.youtube.com/@INDMatrimony/"
              } // fallback to static if no link
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#fff" }}
            >
              <FiYoutube size={22} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;